var React = require('react');

function HeaderHome (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2707 446C2841.8 576 3042.5 605.51 3161 582C3597 495.5 3579.06 0 3898.56 0H3.55762C-22.9424 175.5 102.427 364.571 252.558 425C463.558 509.929 208.558 814.571 487.058 976C652 1071.61 768.558 914.947 929.558 935C1155.06 963.087 1352.47 1358.64 1739 1203.5C2033 1085.5 2065.5 774 2117.5 622C2169.5 470 2252.5 308.975 2413.5 279.5C2574.5 250.025 2664.48 404.993 2707 446Z","fill":"url(#_Header2Gradient)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"_Header2Gradient","x1":"2117.5","y1":"-62.8508","x2":"1725.22","y2":"1315.87","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#007CBB","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#00ACBB","key":1})]))]);
}

HeaderHome.defaultProps = {"viewBox":"0 0 3899 1240","fill":"none"};

module.exports = HeaderHome;

HeaderHome.default = HeaderHome;
